import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { closeDialog } from "../store/dialogSlice";
import { clearAuth } from "../store/authSlice";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const LogoutDialog: React.FC = () => {
  const dispatch = useDispatch();

  // Kontrollera om LogoutDialog ska visas
  const isOpen = useSelector(
    (state: RootState) => state.dialog.activeDialog === "logout"
  );

  // Stäng dialogen
  const handleClose = () => {
    dispatch(closeDialog()); // Stänger den aktuella dialogen
  };

  // Logga ut användaren
  const handleLogout = () => {
    dispatch(clearAuth()); // Rensa auth i Redux
    dispatch(closeDialog()); // Stäng dialogen
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Logga ut</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Är du säker på att du vill logga ut?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Avbryt
        </Button>
        <Button onClick={handleLogout} color="primary">
          Logga ut
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
